import React from "react";
import {
  List,
  TextInput,
  Filter,
  Datagrid,
  TextField,
  DateField,
  RefreshButton,
  ReferenceField,
} from "admin-on-rest";
import { CardActions } from "material-ui/Card";
import { styles } from "./styles";
import "./index.css";
import IconTitle from "../components/icon_title";
import Pagination from "../components/pagination";
import { EditButton, ShowButton, CreateButton } from "../components/button";
import get from "lodash.get";
import { MarketerShow as show } from "./Create";
//MarketerCreate as create1,
// MarketerEdit as edit,
import MainCreate from "./form/MainCreate";
import MainEdit from "./form/MainEdit";
const MarketerActions = ({ resource, basePath, refresh }) => (
  <CardActions
    style={styles.cardActionStyleSmall}
    className="marketers-actions"
  >
    <CreateButton basePath={basePath} />
    <RefreshButton basePath={basePath} refresh={refresh} />
  </CardActions>
);

const MarketersFilter = ({ ...props }) => (
  <Filter {...props}>
    <TextInput
      label="resources.orders.actions.search"
      source="search"
      alwaysOn
    />
  </Filter>
);

export const MarketerCreate = MainCreate;
export const MarketerEdit = MainEdit;
export const MarketerShow = show;

// const PENDING = 2;
// const ACTIVE = 1;

const StatusView = ({ record, source }) => {
  // console.log("record", record);
  const status = get(record, source, 0);
  if (status === 1) {
    return <div>ACTIVE</div>;
  } else {
    return <div>PENDING</div>;
  }
};

export const MarketersList = (props) => (
  <List
    {...props}
    actions={<MarketerActions />}
    filters={<MarketersFilter />}
    title={<IconTitle icon="marketers" title={"resources.marketers.title"} />}
    pagination={<Pagination />}
  >
    <Datagrid bodyOptions={{ showRowHover: true }}>
      <TextField
        label="resources.marketers.fields.first_name"
        source="first_name"
      />
      <TextField
        label="resources.marketers.fields.last_name"
        source="last_name"
      />
      <TextField label="resources.marketers.fields.email" source="email" />
      <StatusView source={"status"} />
      <ReferenceField
        label="resources.marketers.fields.partner_id"
        source="partner_id"
        reference="marketers"
        linkType={false}
        allowEmpty={true}
      >
        <TextField source="nickname" />
      </ReferenceField>
      <DateField
        label="resources.marketers.fields.create_at"
        source="created_at"
      />

      <EditButton
        style={{ width: 50, textAlign: "center" }}
        headerStyle={{ width: 50 }}
      />
      <ShowButton
        style={{ width: 50, textAlign: "center" }}
        headerStyle={{ width: 50 }}
      />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/marketers/index.js